import { render, staticRenderFns } from "./MemberCommunications.vue?vue&type=template&id=61e40b3d&"
import script from "./MemberCommunications.vue?vue&type=script&lang=js&"
export * from "./MemberCommunications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports